import { parseSuggestionTag } from "./suggestionTags";
import SuggestionTagBadges from "./SuggestionTagBadges";

// One suggestion in the Add to Report modals' "points to cover" list: the
// text, with a policy/footage check prefix shown as read-only badges below it
// instead of as "[Policy check · …]".
function SuggestionPoint({ content }: { content: string }) {
  const { text, tag } = parseSuggestionTag(content);
  return (
    <div className="min-w-0">
      <span>{text}</span>
      {tag && <SuggestionTagBadges tag={tag} className="mt-1" />}
    </div>
  );
}

export default SuggestionPoint;
